import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { SetupWizardService } from "@services/setup-wizard.service";
import { isEqual } from "lodash";
@Component({
  selector: "app-wizard-integration-list-item",
  templateUrl: "./wizard-integration-list-item.component.html",
  styleUrls: [
    "./wizard-integration-list-item.component.scss",
    "../../wizard-styles.scss",
  ],
})
export class WizardIntegrationListItemComponent implements OnInit {
  @Input() integration: FormGroup;
  @Input() index: number;
  public isProcessing;
  public initialIntegration;

  constructor(private wizardService: SetupWizardService) {}

  ngOnInit(): void {}

  public getInitialIntegration() {
    return this.wizardService.previousIntegrations.find(
      (integration) => integration.value.id === this.integration.value.id
    )?.value;
  }

  async updateIntegration() {
    this.integration.get("isProcessing").setValue(true);
    this.integration.disable();

    // make sure the event stack for the formGroup for the integration is completed to get current values
    setTimeout(() => {
      const name = this.integration.get("name").value;
      const id = this.integration.get("id").value;
      const updates = this.getChangedValues();
      const justFriendlyNameUpdate =
        Object.keys(updates).length === 1 && updates.friendly_name;

      if (!justFriendlyNameUpdate) {
        this.integration
          .get("tokensProcess")
          .setValue({ message: "processing", status: "processing" });
        this.integration
          .get("termsProcess")
          .setValue({ message: "processing", status: "processing" });
      }
      this.integration.get("status").setValue("processing");
      this.integration.get("message").setValue("");
      this.wizardService.updateIntegation(
        name,
        updates,
        this.index,
        justFriendlyNameUpdate,
        id
      );
    }, 0);
  }

  getChangedValues() {
    const values = this.integration.value;
    this.initialIntegration = this.getInitialIntegration();
    return Object.keys(values).reduce((acc, field) => {
      const isAllAsterisks = /^\*+$/.test(values[field]);
      const ignoreFields = [
        "friendlyNameDisplayed",
        "termsProcess",
        "tokensProcess",
        "status",
        "message",
        "isProcessing",
        'importInfoChanges'
      ];

      return isAllAsterisks ||
        ignoreFields.includes(field) ||
        isEqual(values[field], this?.initialIntegration?.[field])
        ? acc
        : { ...acc, [field]: values[field] };
    }, {}) as any;
  }
}
